import { Theme, css } from '@emotion/react';

export const selectStyles = ({ spacing, typography, colors }: Theme) => css`
  & .MuiSelect-select {
    align-items: center;
    display: flex;
    gap: ${spacing(1)}px;
    padding: ${typography.pxToRem(12.5)} ${typography.pxToRem(14)};
    padding-right: ${spacing(4)}px;
    &:focus {
      background: transparent;
    }
  }

  .MuiSelect-outlined {
    padding-right: ${spacing(4)}px;
  }

  .MuiDisabled {
    background: ${colors.bgLighter};
  }
`;
